
    import '/home/ec2-user/Youlify-Design/components/tab-button/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["tab-button-demo-basic"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/tab-button/index.en-US.md?type=demo')
};